import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=be6a476c&"
import script from "./CommentForm.vue?vue&type=script&lang=js&"
export * from "./CommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports